export default {
  COMMUNITY: {
    QUESTION_TEXT:
      'Möchten Sie eng in die weitere Entwicklung dieser Innovation eingebunden werden und spezifische Inhalte dazu erhalten?',
    ANSWER_YES: 'Ja bitte!',
    ANSWER_NO: 'Nein eher nicht.'
  }
};
